var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconHide({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none",
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#767676",
    fillRule: "evenodd",
    d: "m8.047 5.633 1.89 1.89a5 5 0 0 1 1.734-.425c3.044-.19 5.558 2.297 5.366 5.319a4.9 4.9 0 0 1-.45 1.755l2.741 2.742c1.66-1.087 3.172-2.53 4.484-4.259a.935.935 0 0 0 0-1.124C20.744 7.487 16.585 5 12 5c-1.361 0-2.685.22-3.953.633M20.914 20.5 19.5 21.914l-3.41-3.41c-1.31.443-2.68.678-4.09.678-4.585 0-8.744-2.487-11.812-6.531a.935.935 0 0 1 0-1.125c1.341-1.766 2.891-3.235 4.594-4.33L2.086 4.5l1-1L20.5 20.914zm-6.202-8.202.003-.037c.108-1.625-1.247-2.964-2.887-2.861h-.013zM7.47 9.884a4.9 4.9 0 0 0-.507 1.88c-.192 3.023 2.322 5.51 5.366 5.32a5 5 0 0 0 1.854-.486l-1.836-1.836a3 3 0 0 1-.17.015c-1.64.103-2.995-1.236-2.887-2.861q.006-.098.019-.193z",
    clipRule: "evenodd"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconHide);
export default __webpack_public_path__ + "static/media/icon-hide.19495c29011f6578ab6fa38aa0d4e00f.svg";
export { ForwardRef as ReactComponent };